/* Kandwin Popup — dynamic injection 1781922535 */
(function() {
  // Don't inject on quiz pages (they have their own quiz)
  if (document.getElementById('kandwin-quiz')) return;
  if (document.getElementById('kandwinPopup') || document.getElementById('kandwin-quiz-popup-overlay')) return;
  
  var container = document.createElement('div');
  container.innerHTML = `<!-- Kandwin Quiz Popup -->
<style>
#kandwin-quiz-popup-overlay {
  display: none;
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.6);
  z-index: 99999;
  align-items: center;
  justify-content: center;
}
#kandwin-quiz-popup-overlay.show { display: flex; }
#kandwin-quiz-popup {
  background: #fff;
  border-radius: 12px;
  max-width: 560px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  padding: 40px 32px;
  font-family: 'Poppins',-apple-system,BlinkMacSystemFont,sans-serif;
  color: #121212;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
}
#kandwin-quiz-popup-close {
  position: absolute;
  top: 12px; right: 16px;
  background: none; border: none;
  font-size: 24px; color: #5a5a5a;
  cursor: pointer; line-height: 1;
}
.kqp-step { display: none; }
.kqp-step.active { display: block; animation: kqpFade 0.35s ease; }
@keyframes kqpFade { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
.kqp-label { font-size: 14px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.06em; color: #1e7273; margin-bottom: 6px; text-align: center; }
.kqp-h2 { font-size: 26px; font-weight: 700; line-height: 1.3; margin-bottom: 12px; letter-spacing: -0.01em; color: #121212; text-align: center; }
.kqp-sub { font-size: 15px; color: #5a5a5a; margin-bottom: 36px; line-height: 1.5; text-align: center; }
.kqp-answers { display: flex; flex-direction: column; gap: 14px; }
.kqp-btn {
  display: block; width: 100%; padding: 18px 24px;
  background: #fff; border: 2px solid #e5e7eb; border-radius: 10px;
  font-family: 'Poppins',sans-serif; font-size: 16px; font-weight: 500;
  color: #121212; text-align: left; cursor: pointer; transition: all 0.15s ease; line-height: 1.5;
}
.kqp-btn:hover { border-color: #1e7273; background: #f0faf9; }
.kqp-btn-primary { background: #1e7273; color: #fff; border: none; text-align: center; font-weight: 600; }
.kqp-btn-primary:hover { background: #165a5b; }
.kqp-progress { display: flex; gap: 6px; margin-bottom: 40px; }
.kqp-dot { flex: 1; height: 4px; border-radius: 2px; background: #e5e7eb; transition: background 0.3s; }
.kqp-dot.done, .kqp-dot.active { background: #1e7273; }
.kqp-input { width: 100%; padding: 16px 20px; border: 2px solid #e5e7eb; border-radius: 10px; font-family: 'Poppins',sans-serif; font-size: 16px; color: #121212; background: #fff; }
.kqp-input:focus { outline: none; border-color: #1e7273; }
.kqp-code-box { background: #e8f6f5; border: 2px dashed #1e7273; border-radius: 10px; padding: 28px 24px; text-align: center; margin: 24px 0; }
.kqp-code { font-size: 32px; font-weight: 700; letter-spacing: 0.08em; color: #1e7273; }
.kqp-shop-link { display: inline-flex; align-items: center; justify-content: center; width: 100%; padding: 16px 24px; background: #c16452; color: #fff; border-radius: 10px; text-decoration: none; font-weight: 600; font-size: 16px; margin-top: 14px; }
.kqp-shop-link:hover { filter: brightness(1.1); }
.kqp-timer { text-align: center; margin-top: 20px; }
.kqp-timer span { display: inline-block; background: #fff3e0; border: 1px solid #ffcc80; border-radius: 20px; padding: 8px 20px; font-size: 14px; color: #e65100; }
.kqp-disclaimer { font-size: 12px; color: #5a5a5a; text-align: center; margin-top: 20px; line-height: 1.5; }
.kqp-skip { display: block; text-align: center; margin-top: 20px; font-size: 13px; color: #5a5a5a; text-decoration: underline; cursor: pointer; background: none; border: none; font-family: 'Poppins',sans-serif; width: 100%; }
.kqp-skip:hover { color: #121212; }
.kqp-error { font-size: 12px; color: #c16452; margin-top: 8px; display: none; }
</style>

<div id="kandwin-quiz-popup-overlay">
<div id="kandwin-quiz-popup">
<button id="kandwin-quiz-popup-close" onclick="window.KQP.close()">&times;</button>

<div class="kqp-step active" data-step="0">
  <div class="kqp-label">Foot Pain Quiz</div>
  <h2 class="kqp-h2">Which sounds like you?</h2>
  <p class="kqp-sub">Answer 3 questions and we'll give you <strong>$10 off</strong> the Kandwin 3-in-1 Foot Massager + Foot Care Guide.</p>
  <div class="kqp-answers">
    <button class="kqp-btn kqp-btn-primary" onclick="window.KQP.start()">Start Quiz</button>
  </div>
  <div class="kqp-timer"><span>&#9201; This offer expires in <strong id="kqp-countdown">60</strong>s</span></div>
  <button class="kqp-skip" onclick="window.location.href='https://www.kandwincare.com.au/products/kandwin-3-in-1-foot-massager'">No thanks, I'll pay full price</button>
</div>

<div class="kqp-step" data-step="1">
  <div class="kqp-progress" id="kqp-p1"></div>
  <div class="kqp-label">Question 1 of 3</div>
  <h2 class="kqp-h2">Which sounds most like you right now?</h2>
  <p class="kqp-sub">Pick the one that fits best.</p>
  <div class="kqp-answers">
    <button class="kqp-btn" onclick="window.KQP.select(1,'morning-glass',this)">Every morning, first step out of bed &mdash; it&rsquo;s like walking on glass</button>
    <button class="kqp-btn" onclick="window.KQP.select(1,'wrecked-feet',this)">By the end of the day, my feet are absolutely wrecked</button>
    <button class="kqp-btn" onclick="window.KQP.select(1,'one-spot',this)">There&rsquo;s this one spot that just won&rsquo;t go away</button>
    <button class="kqp-btn" onclick="window.KQP.select(1,'between-visits',this)">I&rsquo;ve seen a specialist but I need something between appointments</button>
  </div>
</div>

<div class="kqp-step" data-step="2">
  <div class="kqp-progress" id="kqp-p2"></div>
  <div class="kqp-label">Question 2 of 3</div>
  <h2 class="kqp-h2">What have you already tried?</h2>
  <p class="kqp-sub">Be honest &mdash; we&rsquo;ve heard it all.</p>
  <div class="kqp-answers" id="kqp-q2"></div>
</div>

<div class="kqp-step" data-step="3">
  <div class="kqp-progress" id="kqp-p3"></div>
  <div class="kqp-label">Question 3 of 3</div>
  <h2 class="kqp-h2">What&rsquo;s the one thing you actually want?</h2>
  <p class="kqp-sub">Last question.</p>
  <div class="kqp-answers">
    <button class="kqp-btn" onclick="window.KQP.select(3,'no-morning-pain',this)">To get out of bed without wincing</button>
    <button class="kqp-btn" onclick="window.KQP.select(3,'survive-shift',this)">To get through the day without my feet throbbing</button>
    <button class="kqp-btn" onclick="window.KQP.select(3,'stop-worrying',this)">To stop worrying about that one spot</button>
    <button class="kqp-btn" onclick="window.KQP.select(3,'skip-appointments',this)">To not have to book another appointment</button>
  </div>
</div>

<div class="kqp-step" data-step="4">
  <div class="kqp-label" id="kqp-result-label"></div>
  <h2 class="kqp-h2" id="kqp-result-heading"></h2>
  <p class="kqp-sub" id="kqp-result-desc" style="margin-bottom:28px;"></p>
  <div style="margin-bottom:20px;">
    <label style="display:block;font-size:14px;font-weight:600;margin-bottom:8px;">Where should we send your $10 off code?</label>
    <input class="kqp-input" type="email" id="kqp-email" placeholder="your@email.com" autocomplete="email">
    <div class="kqp-error" id="kqp-email-error">Please enter a valid email address.</div>
  </div>
  <button class="kqp-btn kqp-btn-primary" onclick="window.KQP.submit()">Get My $10 Off Code</button>
  <p class="kqp-disclaimer">We&rsquo;ll send the code to your inbox. No spam. Unsubscribe anytime.</p>
</div>

<div class="kqp-step" data-step="5">
  <div class="kqp-label">Your code is ready</div>
  <h2 class="kqp-h2">Here&rsquo;s your $10 off</h2>
  <p class="kqp-sub" style="margin-bottom:28px;">Use this code at checkout. We&rsquo;ve also emailed it to you.</p>
  <div class="kqp-code-box">
    <div class="kqp-code">QUIZ10</div>
    <div style="font-size:13px;color:#5a5a5a;margin-top:4px;">$10 off the Kandwin 3-in-1 Foot Massager + Foot Care Guide</div>
  </div>
  <a href="https://www.kandwincare.com.au/products/kandwin-3-in-1-foot-massager" class="kqp-shop-link">Shop Now</a>
  <p class="kqp-disclaimer">Check your inbox &mdash; we&rsquo;ve sent your code and we&rsquo;ll share what your result means over the next few days.</p>
</div>

</div>
</div>

<script>
(function() {
  if (window.KQP) return;
  var KQP = window.KQP = {};
  
  var q2opts = {
    'morning-glass': [{v:'stretching',l:'Stretching before I get out of bed'},{v:'ice-bottle',l:'Rolling my foot on an ice bottle or ball'},{v:'orthotics',l:'$500+ orthotics (they help, but not enough)'},{v:'put-up-with-it',l:'Honestly? Just put up with it'}],
    'wrecked-feet': [{v:'better-shoes',l:'Tried better shoes or inserts'},{v:'soaking',l:'Soaking my feet after work'},{v:'painkillers',l:'Painkillers to get through the shift'},{v:'nothing-yet',l:'Nothing yet - just dealing with it'}],
    'one-spot': [{v:'googling',l:'Googling it (and getting more worried)'},{v:'ignoring',l:'Ignoring it, hoping it goes away'},{v:'tennis-ball',l:'Rolling it on a tennis ball or spike ball'},{v:'saw-specialist',l:'Already saw a specialist about it'}],
    'between-visits': [{v:'orthotics-specialist',l:'Orthotics prescribed by my specialist'},{v:'shockwave',l:'Shockwave therapy or dry needling'},{v:'exercises',l:'Stretches and exercises they gave me'},{v:'multiple-specialists',l:'Seen multiple specialists - still not 100%'}]
  };
  
  var results = {
    'morning-glass': {h:"Your feet shouldn't decide how your day starts",l:"You're a Morning Glass Walker",d:"That glass-in-the-foot feeling every morning - it's exhausting. You've tried stretching, maybe orthotics. The Kandwin's cold therapy targets inflammation before it wakes up with you. 6 minutes on the couch, and morning feels different."},
    'wrecked-feet': {h:"Your feet carry you all day. Return the favour.",l:"You're a Post-Shift Survivor",d:"Throbbing feet after a double shift, every single day. You've soaked them, bought better shoes, maybe popped painkillers. The Kandwin's acupressure + deep tissue combination gives you recovery at home - no appointment needed."},
    'one-spot': {h:"One spot shouldn't take up this much headspace",l:"You're a Targeted Relief Seeker",d:"That specific spot on the side, under the arch, or on the ball of your foot - it lives rent-free in your mind. You've googled it, rolled it, maybe ignored it. The Kandwin's 3-in-1 system lets you target exactly where it hurts."},
    'between-visits': {h:"Your specialist gave you a routine. Fill the gaps at home.",l:"You're a Home Maintenance Pro",d:"Orthotics. Shockwave. Exercises. But those 4 weeks between appointments feel long - and expensive. The Kandwin bridges the gap: cold therapy, acupressure, and deep tissue on your schedule, for a fraction of the cost."}
  };
  
  var state = {seg:null,q1:null,q2:null,q3:null};
  var timerInterval = null;
  
  function prog(n) {
    var h=''; for(var i=0;i<3;i++) h+='<div class="kqp-dot'+(i<n-1?' done':i===n-1?' active':'')+'"></div>';
    return h;
  }
  
  function go(n) {
    var ss = document.querySelectorAll('#kandwin-quiz-popup .kqp-step');
    for(var i=0;i<ss.length;i++) ss[i].classList.remove('active');
    var el = document.querySelector('#kandwin-quiz-popup [data-step="'+n+'"]');
    if(!el) return;
    if(n<=3){if(n===1)document.getElementById('kqp-p1').innerHTML=prog(1);if(n===2)document.getElementById('kqp-p2').innerHTML=prog(2);if(n===3)document.getElementById('kqp-p3').innerHTML=prog(3);}
    if(n===4){var r=results[state.seg]||results['morning-glass'];document.getElementById('kqp-result-label').textContent=r.l;document.getElementById('kqp-result-heading').textContent=r.h;document.getElementById('kqp-result-desc').textContent=r.d;}
    el.classList.add('active');
  }
  
  KQP.start = function() { clearInterval(timerInterval); go(1); };
  
  KQP.select = function(qn, val, btn) {
    var btns = btn.parentElement.querySelectorAll('.kqp-btn');
    for(var i=0;i<btns.length;i++){btns[i].style.background='#fff';btns[i].style.borderColor='#e5e7eb';btns[i].style.fontWeight='500';}
    btn.style.background='#e8f6f5';btn.style.borderColor='#1e7273';btn.style.fontWeight='600';
    if(qn===1){state.q1=val;state.seg=val;
      var c=document.getElementById('kqp-q2'),o=q2opts[val]||q2opts['morning-glass'],h='';
      for(var i=0;i<o.length;i++) h+='<button class="kqp-btn" onclick="window.KQP.select(2,\''+o[i].v+'\',this)">'+o[i].l+'</button>';
      c.innerHTML=h;
    }else if(qn===2){state.q2=val;}else if(qn===3){state.q3=val;}
    setTimeout(function(){go(qn+1);},200);
  };
  
  KQP.submit = function() {
    var email = document.getElementById('kqp-email').value.trim();
    if(!email||email.indexOf('@')<0||email.indexOf('.')<0){document.getElementById('kqp-email-error').style.display='block';return;}
    document.getElementById('kqp-email-error').style.display='none';
    localStorage.setItem(QP_KEY,Date.now().toString());if(window._learnq&&window._learnq.push) window._learnq.push(['identify',{$email:email,quiz_segment:document.getElementById('kqp-result-label').textContent,quiz_q1:state.q1,quiz_q2:state.q2,quiz_q3:state.q3,quiz_discount_code:'QUIZ10','$source':'Foot Pain Quiz Popup'}]);
    fetch('https://a.klaviyo.com/api/profile-subscription-bulk-create-jobs/',{
      method:'POST',
      headers:{'Content-Type':'application/json','Authorization':'Klaviyo-API-Key pk_XCrSzd','revision':'2026-04-15'},
      body:JSON.stringify({data:{type:'profile-subscription-bulk-create-job',attributes:{profiles:{data:[{type:'profile',attributes:{email:email,subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}}}]},historical_import:false}}})
    }).catch(function(){});
    go(5);
  };
  
  KQP.close = function() { clearInterval(timerInterval); document.getElementById('kandwin-quiz-popup-overlay').classList.remove('show'); window._popupShowing = false; localStorage.setItem(QP_KEY, Date.now().toString()); };
  
  // Show popup logic: show on non-quiz pages after 8 seconds or exit intent
  var productPage = 'https://www.kandwincare.com.au/products/kandwin-3-in-1-foot-massager';
  if (window.location.pathname.indexOf('/pages/quiz') === -1) {
    
  // Ensure _learnq is available before async Klaviyo loads
  window._learnq = window._learnq || [];
window._popupShowing = false;
var QP_KEY = 'kandwin_quiz_popup';
    return; // Quiz popup disabled — simple popup is primary
    var closedAt = localStorage.getItem(QP_KEY);
    if (closedAt && (Date.now() - parseInt(closedAt)) < 7 * 24 * 60 * 60 * 1000) return;
    var shown = false;
    function show() { if(shown || window._popupShowing) return; if(!localStorage.getItem('kandwin_popup_closed')) return; shown=true; window._popupShowing=true; clearInterval(timerInterval); document.getElementById('kandwin-quiz-popup-overlay').classList.add('show'); startTimer(); }
    
    function startTimer() {
      var sec=60, el=document.getElementById('kqp-countdown');
      timerInterval = setInterval(function(){
        sec--; if(el)el.textContent=sec;
        if(sec<=0){clearInterval(timerInterval);localStorage.setItem(QP_KEY,Date.now().toString());window.location.href=productPage;}
      },1000);
    }
    
    // Exit intent
    document.addEventListener('mouseout',function(e){if(e.clientY<=0&&!shown)show();});
    // Fallback: show after 15s
    setTimeout(function(){if(!shown)show();},15000);
  }
})();
</script>
<!-- End Kandwin Quiz Popup -->

<!-- Kandwin Exit-Intent Popup -->
<style>
.kandwin-popup-overlay {
  display: none;
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(0,0,0,0.5);
  z-index: 99999;
  align-items: center;
  justify-content: center;
}
.kandwin-popup-overlay.show { display: flex; }
.kandwin-popup {
  background: #fff;
  border-radius: 12px;
  padding: 40px 32px;
  max-width: 460px;
  width: 90%;
  text-align: center;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  position: relative;
  box-shadow: 0 20px 60px rgba(0,0,0,0.2);
}
.kandwin-popup-close {
  position: absolute;
  top: 12px; right: 16px;
  background: none; border: none;
  font-size: 24px; cursor: pointer;
  color: #999;
}
.kandwin-popup-icon { font-size: 48px; margin-bottom: 12px; }
.kandwin-popup h2 {
  font-size: 22px; margin: 0 0 8px; color: #1a1a1a;
  line-height: 1.3;
}
.kandwin-popup p {
  font-size: 15px; color: #666; margin: 0 0 8px;
}
.kandwin-popup .free-badge {
  display: inline-block;
  background: #2e7d32;
  color: #fff;
  padding: 4px 12px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 12px;
}
.kandwin-popup .price-strike {
  text-decoration: line-through;
  color: #999;
  font-size: 14px;
}
.kandwin-popup input[type="email"] {
  width: 100%;
  padding: 14px 16px;
  border: 2px solid #ddd;
  border-radius: 8px;
  font-size: 16px;
  margin: 12px 0;
  box-sizing: border-box;
}
.kandwin-popup input[type="email"]:focus {
  border-color: #1f7174;
  outline: none;
}
.kandwin-popup .submit-btn {
  width: 100%;
  padding: 14px;
  background: #1f7174;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
}
.kandwin-popup .submit-btn:hover { background: #185a5d; }
.kandwin-popup .submit-btn.loading { opacity: 0.7; pointer-events: none; }
.kandwin-popup .success-msg {
  display: none;
  font-size: 16px;
  color: #2e7d32;
  font-weight: 600;
  padding: 20px;
}
.kandwin-popup .no-thanks {
  display: block;
  margin-top: 12px;
  font-size: 13px;
  color: #999;
  cursor: pointer;
  background: none; border: none;
  width: 100%;
}
</style>

<div class="kandwin-popup-overlay" id="kandwinPopup">
  <div class="kandwin-popup">
    <button class="kandwin-popup-close" onclick="closeKandwinPopup()">&times;</button>
    <div class="kandwin-popup-icon">📖</div>
    <div class="free-badge">$10 OFF + FREE GUIDE</div>
    <h2>Get $10 off your own Kandwin 3-in-1 Foot Massager</h2>
    <p>Plus the Plantar Fasciitis Foot Care Guide (valued at $49.95) — yours free. Cold therapy. Acupressure. Deep tissue. Free shipping. 30-day trial.</p>
    <p style="font-size:13px;color:#999;">Start relieving foot pain in 6 minutes a day.</p>
    
    <div id="kandwinPopupForm">
      <input type="email" id="kandwinPopupEmail" placeholder="Enter your email" required>
      <button class="submit-btn" onclick="submitKandwinPopup()">Send Me $10 Off</button>
    </div>
    
    <div class="success-msg" id="kandwinPopupSuccess">
      Your $10 off the massager + free Foot Care Guide is <strong>QUIZ10</strong>.
    </div>
    
    <button class="no-thanks" onclick="closeKandwinPopup()">No thanks, I'll pay full price</button>
  </div>
</div>

<script>
(function() {
  if (window.kandwinPopupInit) return;
  window.kandwinPopupInit = true;

  const CLOSE_KEY = 'kandwin_popup_closed';
  const SUBSCRIBED_KEY = 'kandwin_popup_subscribed';
  
  // Don't show if already subscribed or recently closed
  if (localStorage.getItem(SUBSCRIBED_KEY)) return;
  
  const closedAt = localStorage.getItem(CLOSE_KEY);
  if (closedAt && (Date.now() - parseInt(closedAt)) < 7 * 24 * 60 * 60 * 1000) return;
  
  let shown = false;
  
  function showPopup() {
    if (shown || window._popupShowing) return;
    shown = true;
    window._popupShowing = true;
    document.getElementById('kandwinPopup').classList.add('show');
  }
  
  // Show after 5 seconds
  setTimeout(function() { showPopup(); }, 5000);
  
  // Exit intent as backup
  document.addEventListener('mouseout', function(e) {
    if (e.clientY <= 0 && !shown) showPopup();
  });
})();

function closeKandwinPopup() {
  document.getElementById('kandwinPopup').classList.remove('show');
  window._popupShowing = false;
  localStorage.setItem('kandwin_popup_closed', Date.now().toString());
}

function submitKandwinPopup() {
  const email = document.getElementById('kandwinPopupEmail').value.trim();
  if (!email || !email.includes('@')) return;
  
  const btn = document.querySelector('#kandwinPopup .submit-btn');
  btn.classList.add('loading');
  btn.textContent = 'Sending...';
  
  // Subscribe via Klaviyo
  if (window._learnq) {
    window._learnq.push(['identify', { '$email': email }]);
  }
  
  // Subscribe to Klaviyo list via client-side (no API key needed)
  fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
    method: 'POST',
    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    body: 'g=SETKP6&email=' + encodeURIComponent(email) + '&$source=KandwinPopup'
  });
  
  // Show success
  document.getElementById('kandwinPopupForm').style.display = 'none';
  document.getElementById('kandwinPopupSuccess').style.display = 'block';
  document.querySelector('#kandwinPopup .no-thanks').textContent = 'Close';
  localStorage.setItem('kandwin_popup_subscribed', 'true');
  
  btn.classList.remove('loading');
}
</script>`;
  
  // Append to body
  if (document.body) {
    document.body.appendChild(container);
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      document.body.appendChild(container);
    });
  }
})();
